import { render, staticRenderFns } from "./departmentSelect.vue?vue&type=template&id=54694134"
import script from "./departmentSelect.vue?vue&type=script&lang=js"
export * from "./departmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports